import React from 'react';

interface Props {}

const CustomControls: React.FC<Props> = ({ children }) => {
	return <>{children}</>;
};

export default CustomControls;
